import { Checkbox } from '@cian/ui-kit';
import { useCallback, ChangeEvent } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDealTypeFilter as selectByHomeownerFilter } from 'shared/selectors/advancedFilters';

export const ByHomeownerContainer = () => {
  const { value } = useSelector(selectByHomeownerFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setIsByHomeowner', arguments: [newValue || /* istanbul ignore next */ null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label="От собственника" checked={!!value} onChange={handleChange} />
    </InlineFilter>
  );
};
